import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Icon from 'components/Icon';
import OnScreen from 'components/OnScreen';

import './RelatedArticleBlock.module.scss';

export const backgroundColor = {
    white: 'white',
    gray: 'gray',
};

const RelatedArticleBlock = ({
    title,
    heading,
    category,
    link,
    backgroundColor,
    isExternal,
    place,
    inRichText
}) => {
    const ContainerElement = link ? 'a' : 'div';

    return (
        <div 
            className={
                cn('related-article-block', {
                    ['related-article-block_place_' + place]: place,
                    ["related-article-block_in-rich-text"]: inRichText
                })
            }
        >
            <ContainerElement
                className={
                    cn('related-article-block__container', {
                        ['related-article-block__container_theme_' + backgroundColor]: backgroundColor,
                        ['related-article-block__container_place_' +  place]: place
                    })
                }
                {...(link && {
                    href: link,
                    ...(isExternal && {target: "_blank"})
                })}
            >
                <div className='related-article-block__content'>
                    {title && <span className='related-article-block__title'>{title}</span>}
                    {heading && <p className='related-article-block__heading'>{heading}</p>}
                    {category && <span className='related-article-block__category'>{category}</span>}
                </div>
                {link && <div className='related-article-block__icon-container'>
                    <Icon icon={isExternal ? "share" : "arrow-right"} className='related-article-block__icon' />
                </div>}
            </ContainerElement>
        </div>
    )
};

RelatedArticleBlock.defaultProps = {
    backgroundColor: backgroundColor.gray
}

RelatedArticleBlock.propTypes = {
    title: PropTypes.string,
    heading: PropTypes.string,
    category: PropTypes.string,
    link: PropTypes.string,
    isExternal: PropTypes.bool,
    backgroundColor: PropTypes.oneOf(Object.values(backgroundColor)),
    place: PropTypes.oneOf(['feature-article']),
    inRichText: PropTypes.bool
};

export default OnScreen(RelatedArticleBlock);



// WEBPACK FOOTER //
// ./src/components/RelatedArticleBlock/RelatedArticleBlock.jsx